import React from "react";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import LabelsGrid from "./grid/LabelsGrid";
import {LabelsTranslationKey} from "./LabelsTranslationKey";


export default function LabelsPage() {

    return (
        <Page>
            <PageHeader>
                <PageTitle title={t(LabelsTranslationKey.TITLE)} />
            </PageHeader>
            <PageContent>
                <LabelsGrid />
            </PageContent>
        </Page>
    )
}